import angular from 'angular';

export default class RegroupementSitesController {
	static $inject = [
		'$scope',
		'$state',
		'$uibModal',
		'RegroupementSitesService',
		'notification',
		'$translate',
		'moment',
		'ModalService',
		'localStorageService'
	];

	constructor($scope, $state, $uibModal, RegroupementSitesService, notification, $translate, moment, ModalService, localStorageService) {
		Object.assign(this, {
			$scope,
			$state,
			$uibModal,
			RegroupementSitesService,
			localStorageService,
			notification,
			$translate,
			moment,
			ModalService,
			loading: false
		});
	}

	async $onInit() {
		await this.loadSocietes();
		const societeId = this.localStorageService.get('STOCK_CONFIG_GRPSITE_SOCIETE_ID');

		if (this.societes.length > 0) {
			this.idSociete = societeId || this.societes[0].id;
		}

		if (this.idSociete) {
			await this.loadRegroupementSites(this.idSociete);
			if (this.regroupementSites.length > 0) {
				await this.loadSites(this.idSociete);
			}
		}

		this.$scope.$watch(
			() => this.idSociete,
			async (newValue, oldValue) => {
				if (newValue === oldValue) return;
				this.localStorageService.set('STOCK_CONFIG_GRPSITE_SOCIETE_ID', newValue);
				await this.loadRegroupementSites(newValue);
				if (this.regroupementSites.length > 0) {
					await this.loadSites(newValue);
				}
			},
			true
		);
	}

	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.RegroupementSitesService.getSocietesCom();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadSites(idSociete) {
		this.startLoading();
		try {
			this.sitesList = await this.RegroupementSitesService.getSitesCommerciauxBySociete(idSociete);

			if (this.sitesList.length > 0) {
				this.sitesWithGroup = angular.copy(this.sitesList);

				this.sitesWithGroup.map((site) => ({
					...site,
					groupe: null,
					idStockGroupe: null
				}));

				this.sitesWithGroup.forEach((site) => {
					site.groupe = this.regroupementSites.find((groupe) => groupe.sites.some((groupSite) => groupSite.id === site.id)) || null;
					site.idStockGroupe = site.groupe ? site.groupe.id : null;
				});
			} else {
				this.sitesWithGroup = [];
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	//getRegroupementSites
	async loadRegroupementSites(idSociete) {
		this.startLoading();
		try {
			this.regroupementSites = await this.RegroupementSitesService.getRegroupementSitesBySociete(idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	updateGroupe(idSite) {
		const _this = this;
		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: true,
			windowClass: 'modern-modal',
			template: `                
                <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                    <div class="mas-col-fit">
                        <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                            <span style="color: white" aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><span translate="REGROUPEMENT_SITES.ADD_SITE"></span></h4>
                    </div>
                </div>                
                <div class="modal-body" style="min-height: 500px">
                    <div class="mas-col-fill">
                        <form name="form">
                            <div class="mas-row">
                                <div class="mas-col-12">
                                    <div class="form-group">
                                        <label class="col-xs-fit control-label" for="groupeCode">
                                            <span class="field-label mandatory-field" translate="REGROUPEMENT_SITES.GROUPE_CODE"></span>
                                            <span ng-show="!$ctrl.isCodeUnique($ctrl.groupe.code)" class="glyphicon glyphicon-exclamation-sign" style="color: red"
                                                tooltip-placement="right" uib-tooltip=" {{'REGROUPEMENT_SITES.CODE_UNIQUE'|translate}} "></span>
                                        </label>
                                        <div class="col-xs-fit">
                                            <input
                                                class="form-control display-validation"
                                                id="groupeCode"
                                                name="groupeCode"
                                                ng-model="$ctrl.groupe.code"
                                                maxlength="100"
                                                    ng-disabled="$ctrl.selectedSites.length === 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="mas-col-12">
                                    <div class="form-group">
                                        <label class="col-xs-fit control-label" for="groupeLibelle">
                                            <span class="field-label mandatory-field" translate="REGROUPEMENT_SITES.GROUPE_LIBELLE"></span>
                                            <span ng-show="!$ctrl.isLibelleUnique($ctrl.groupe.libelle)" class="glyphicon glyphicon-exclamation-sign" style="color: red"
                                                tooltip-placement="right" uib-tooltip=" {{'REGROUPEMENT_SITES.LIBELLE_UNIQUE'|translate}} "></span>
                                        </label>
                                        <div class="col-xs-fit">
                                            <input
                                                class="form-control display-validation"
                                                id="groupeLibelle"
                                                name="groupeLibelle"
                                                ng-model="$ctrl.groupe.libelle"
                                                maxlength="100"
                                                ng-disabled="$ctrl.selectedSites.length === 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="mas-col-12 mas-mb-20">
                                    <div class="form-group">
                                        <label class="control-label">
                                            <span class="field-label" for="sites">
                                                {{'REGROUPEMENT_SITES.SITES_ASSOCIES'|translate}}
                                            </span>
                                        </label>
                                        <isteven-multi-select id="filtreSites" name="filtreSites"
                                            input-model="$ctrl.inputFiltreSites" output-model="$ctrl.outputFiltreSites"
                                            on-item-click="$ctrl.saveSelectedSites()" on-select-all="$ctrl.saveSelectedSites()"
                                            on-select-none="$ctrl.saveSelectedSites()" search-property="libelle"
                                            max-labels="5" max-height="200px" tick-property="selected" output-properties="id idSociete"
                                            button-label="libelle" item-label="libelle">
                                        </isteven-multi-select>
                                    </div>
                                </div>
                                <div class="mas-col-12 mas-p-10" ng-repeat="site in $ctrl.selectedSites track by site.id" style="list-style-type: none; padding: 5px 0; display: flex; align-items: center;">
                                    <span style="flex-grow: 1;">{{site.libelle}}</span>
                                    <button ng-hide="$ctrl.selectedSites[0].id === site.id" ng-click="$ctrl.removeSite(site.id)" style="background: none; border: none; color: red; font-size: 20px; cursor: pointer;">
                                        &times;
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">        
                    <button class="btn btn-primary" type="button" ng-disabled="!$ctrl.isFormValid($ctrl.groupe)" ng-click="$ctrl.validate($ctrl.groupe)">
                        <span translate="REGROUPEMENT_SITES.SAVE"></span>
                    </button>
                    <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                        <span class="massia-icon-door_exit"></span>
                        <span class="hidden-xs" translate="FERMER"></span>
                    </button>
                </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					this.groupe = _this.regroupementSites.find((group) => group.sites.some((site) => site.id === idSite));
					this.selectedSites = this.groupe.sites;

					// ISTEVEN MULTI SELECT
					const isSoloSite = (site) =>
						_this.regroupementSites.some((group) => {
							const foundSite = group.sites.find((s) => s.id === site.id);
							return foundSite && group.sites.length < 2;
						});

					const isInGroup = (site) => this.groupe.sites.some((s) => s.id === site.id);
					this.inputFiltreSites = _this.sitesList
						.filter((site) => site.id !== idSite && (isInGroup(site) || isSoloSite(site)))
						.map((site) => ({
							...site,
							selected: this.groupe.sites.some((groupeSite) => groupeSite.id === site.id)
						}));

					this.saveSelectedSites = () => {
						this.selectedSites = [this.selectedSites[0], ...this.inputFiltreSites.filter((site) => site.selected)];
					};

					//LOGIC
					this.isFormValid = (groupe) => {
						return this.isCodeUnique(groupe.code) && this.isLibelleUnique(groupe.libelle);
					};
					this.isCodeUnique = (code) => {
						return (
							this.selectedSites.length <= 1 || (code && code.trim() !== '' && !this.selectedSites.some((site) => site.code === code))
						);
					};
					this.isLibelleUnique = (libelle) => {
						return (
							this.selectedSites.length <= 1 ||
							(libelle && libelle.trim() !== '' && !this.selectedSites.some((site) => 'Groupe ' + site.libelle === libelle))
						);
					};

					this.removeSite = (siteId) => {
						this.selectedSites = this.selectedSites.filter((site) => site.id !== siteId);

						this.inputFiltreSites = this.inputFiltreSites.map((site) => ({
							...site,
							selected: this.selectedSites.some((selectedSite) => selectedSite.id === site.id)
						}));

						if (this.selectedSites.length === 1) {
							this.groupe.code = this.selectedSites[0].code;
							this.groupe.libelle = 'Groupe ' + this.selectedSites[0].libelle;
						}
					};
					// CALLBACKS
					this.validate = (groupe) => {
						groupe.sites = this.selectedSites;
						$uibModalInstance.close(groupe);
					};

					this.close = () => $uibModalInstance.dismiss('cancel');
					//
				}
			]
		});
		modalInstance.result.then(function (result) {
			_this.manageGroupe(result);
		});
	}

	manageGroupe(groupeManaged) {
		// Identifier les groupes modifier et on supprimer les orfelins
		const groupeToDeleteIds = new Set(
			this.regroupementSites
				.filter((grpSite) => {
					// Ne pas supprimer le groupe actuel
					if (grpSite.id === groupeManaged.id) return false;

					var siteIds = grpSite.sites.map((site) => site.id);

					// Check if the single site in the group is in the managed group
					const siteInManagedGroup = groupeManaged.sites.some(({ id }) => siteIds.includes(id));

					return siteInManagedGroup;
				})
				.map(({ id }) => id)
		);
		//retire les groupes à supprimer
		this.regroupementSites = this.regroupementSites.filter((siteGroup) => !groupeToDeleteIds.has(siteGroup.id));

		// Rassembler les identifiants des sites regroupés et identifier les sites quabout:blank#blockedi ne sont dans aucun groupe
		const idsGrouped = new Set(this.regroupementSites.flatMap((siteGroup) => siteGroup.sites.map((site) => site.id)));
		const sitesIdNotInGroup = this.sitesList.filter((site) => !idsGrouped.has(site.id)).map((x) => x.id);

		// on renome le groupe si un seul site restant lors d'un dégroupage
		var isDegroupedAndSolo = groupeManaged.sites.length === 1;
		if (isDegroupedAndSolo) {
			const site = this.sitesList.find((x) => x.id === groupeManaged.sites[0].id);
			var labelGeneric = 'Groupe ' + site.libelle;
			groupeManaged.code = site.code;
			groupeManaged.libelle = labelGeneric;
		}

		// Créer de nouveaux groupes pour les sites non regroupés et mettre à jour les informations des sites
		sitesIdNotInGroup.forEach((siteId) => {
			const site = this.sitesList.find((x) => x.id === siteId);

			var labelGeneric = 'Groupe ' + site.libelle;

			const newIndex = Math.max(...this.regroupementSites.map((x) => x.id)) + 1;
			const newGroup = {
				id: newIndex,
				code: site.code,
				libelle: labelGeneric,
				sites: [site]
			};

			if (groupeManaged.id !== null && groupeManaged.sites?.length > 1) {
				newGroup.id = groupeManaged.id;
				newGroup.code = groupeManaged.code;
				newGroup.libelle = groupeManaged.libelle;
			}
			this.regroupementSites.push(newGroup);
		});

		// Mettre à jour tous les sites avec leurs nouvelles informations de groupe
		this.sitesWithGroup.forEach((site) => {
			const groupe = this.regroupementSites.find((g) => g.sites.some((s) => s.id === site.id));
			if (groupe) {
				site.idStockGroupe = groupe.id;
				site.groupe = groupe;
			}
		});
	}

	getSiteLies(idStockGroupe) {
		const groupe = this.regroupementSites.find((x) => x.id === idStockGroupe);
		if (!groupe) return [];
		return groupe.sites;
	}

	getIsActiveRowCss(isGrouped) {
		return {
			'background-color': isGrouped ? 'gray' : 'null',
			color: isGrouped ? 'white' : 'null'
		};
	}

	async sauvegarder() {
		this.startLoading();
		try {
			const dataToSend = angular.copy(this.regroupementSites);
			dataToSend.forEach((group) => {
				group.sites.forEach((site) => {
					delete site.groupe;
					delete site.idStockGroupe;
				});
			});

			await this.RegroupementSitesService.updateRegroupementSites(this.idSociete, dataToSend);

			this.notification.success('REGROUPEMENT_SITES.SUCCESS_UPDATE');
		} catch (ex) {
			console.log('🔥: RegroupementSitesController -> sauvegarder -> ex', ex);
			this.notification.error(ex.data);
			return false;
		} finally {
			this.stopLoading();
		}
	}

	debug() {
		console.log('🔥: this.regroupementSites', this.regroupementSites);
		console.log('🔥: this.sitesWithGroup', this.sitesWithGroup);
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
